import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { pluralization, defaultInterpolations } from 'libs/utils/i18n';

function useTranslate(prefix) {
  const intl = useIntl();
  return useCallback((suffix, values, pluralize) => {
    const id = prefix ? "".concat(prefix, ".").concat(suffix) : suffix;
    const pluralizeFunc = pluralization(intl.locale);
    const translationKey = pluralize ? "".concat(id, ".").concat(pluralizeFunc(pluralize.count)) : id;
    if (intl.messages[translationKey] === '') return '';
    if (!values) return intl.formatMessage({
      id: translationKey
    });
    return intl.formatMessage({
      id: translationKey
    }, _objectSpread(_objectSpread({}, defaultInterpolations), values));
  }, [intl, prefix]);
}

export default useTranslate;